// src/components/Leadership.jsx
import React from 'react';
import { motion } from 'framer-motion';

// Import the specific images
import hussainImage from '../assets/images/hussain.jpeg';
import grandImage from '../assets/images/grand.png';
import chairmanImage from '../assets/images/chairman.png';
import directorimage from '../assets/images/director.png';
import hadiimg from '../assets/images/hadi.png';

const leadership = [
  {
    id: 1,
    name: "MR. ABDUL HADI ALAFOO",
    position: "Founder",
    bio: "The late Mr. Abdul Hadi Alafoo founded the company in 1961 with a vision to deliver quality, integrity, and innovation in contracting. His dedication and foresight laid the foundation for one of Bahrain’s most respected companies, and his legacy continues to guide and inspire us today.",
    photo: grandImage
  }
  ,
  {
    id: 2,
    name: "MR. EBRAHIM ALAFOO",
    position: "Chairman",
    bio: "As Chairman, Mr. Ebrahim Alafoo upholds the company’s legacy of quality, integrity, and innovation. He provides strategic direction and guidance, ensuring sustainable growth while strengthening relationships with clients, partners, and the community.",
    photo: chairmanImage
  },
  {
    id: 3,
    name: "MR. ABDUL REDHA ALAFOO",
    position: "Director of Operations",
    bio: "As Director of Operations, Mr. Abdul Redha Alafoo leads our team in delivering projects with safety, efficiency, and quality. By optimizing resources, streamlining processes, and fostering collaboration, he ensures every project is completed on time, within budget, and to the highest standards.",
    photo: directorimage
  },
  {
    id: 4,
    name: "MR. HUSSAIN ALAFOO",
    position: "Roads & Traffic Manager",
    bio: "As Roads & Traffic Manager, Mr. Hussain Alafoo leads the planning and execution of infrastructure projects with a strong emphasis on safety, efficiency, and sustainability. His expertise ensures that complex road and traffic solutions are delivered on time, within budget, and to the highest quality standards.",
    photo: hussainImage
  },
  {
    id: 5,
    name: "MR. HADI ALAFOO",
    position: "Admin & Finance Manager",
    bio: "As Admin & Finance Manager, Mr. Hadi Alafoo oversees the company’s financial strategy, administration, and resource management. With a focus on sustainability and efficiency, he ensures that every project is supported by strong financial planning and operational excellence, driving long-term growth and stability.",
    photo: hadiimg
  }

];

const Leadership = () => {
  const firstLeader = leadership[0];
  const otherLeaders = leadership.slice(1);

  return (
    <section id="leadership" className="leadership-section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <h2>Our Leadership Team</h2>
          <p className="section-intro">
            The driving force behind ABDULHADI AL-AFOO W.L.L's success - a team of
            experienced professionals committed to excellence in Bahrain's construction sector.
          </p>

          {/* First Leader (Centered at top) */}
          <div className="first-leader-container">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "0px 0px -50px 0px" }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="leader-card first-leader"
            >
              <div className="leader-photo">
                <img src={firstLeader.photo} alt={firstLeader.name} />
              </div>
              <div className="leader-info">
                <h3>{firstLeader.name}</h3>
                <p className="position">{firstLeader.position}</p>
                <p className="bio">{firstLeader.bio}</p>
              </div>
            </motion.div>
          </div>

          {/* Other Leaders (Row below) */}
          <div className="other-leaders-grid">
            {otherLeaders.map((leader, index) => (
              <motion.div
                key={leader.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "0px 0px -50px 0px" }}
                transition={{ duration: 0.5, delay: (index + 1) * 0.1 }}
                className="leader-card"
              >
                <div className="leader-photo">
                  <img src={leader.photo} alt={leader.name} />
                </div>
                <div className="leader-info">
                  <h3>{leader.name}</h3>
                  <p className="position">{leader.position}</p>
                  <p className="bio">{leader.bio}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Leadership;